import React from "react";

/* ── Image imports ── */
import HeroBgImg from "../../../asset/images/life-at-ador/hero-bg.webp";
import BcSepIcon from "../../../asset/images/about/breadcrumb-separator.svg";
import AdorLogo from "../../../asset/images/life-at-ador/ador-logo.png";

/* Employee photos (optional — remove img tags if not used) */
// import Photo1 from "../../../asset/images/life-at-ador/employee-1.webp";
// import Photo2 from "../../../asset/images/life-at-ador/employee-2.webp";
// import Photo3 from "../../../asset/images/life-at-ador/employee-3.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .la { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══════════════════════════════════════════
     1. HERO
  ══════════════════════════════════════════ */
  .la-hero {
    position: relative;
    width: 100%;
    height: 460px;
    overflow: hidden;
  }

  .la-hero-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
    display: block;
  }

  .la-hero-overlay {
    position: absolute;
    inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.70) 0%,
    //   rgba(0,0,0,0.35) 55%,
    //   rgba(0,0,0,0.05) 100%
    // );
  }

  .la-hero-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 102px;
    max-width: 1600px;
    margin: 0 auto;
    left: 0; right: 0;
  }

  .la-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 600;
    color: #ffffff;
    line-height: 120%;
    margin-bottom: 15px;
  }

  .la-hero-divider {
    width: 559px;
    height: 2px;
    background: #EB2019;
    border: none;
    margin-bottom: 15px;
  }

  .la-hero-desc {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 160%;
    max-width: 501px;
  }

  /* ══════════════════════════════════════════
     2. BREADCRUMB
  ══════════════════════════════════════════ */
  .la-breadcrumb {
    width: 100%;
    padding: 40px 0 0 0;
  }

  .la-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .la-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    display: flex;
    align-items: center;
    transition: color 0.15s;
  }

  .la-bc-item:hover { color: #EB2019; }

  .la-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 8px;
    flex-shrink: 0;
  }

  .la-bc-item.active {
    color: #202020;
    font-weight: 500;
  }

  /* ══════════════════════════════════════════
     SHARED INNER
  ══════════════════════════════════════════ */
  .la-inner {
    // max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    background:#F5F5F5;
  }

  /* ══════════════════════════════════════════
     3. INTRO BANNER
  ══════════════════════════════════════════ */
  .la-intro {
    padding: 40px 0px 120px 0px;
  }

  .la-intro-inner {
    display: flex;
    align-items: center;
    gap: 60px;
    border-radius: 4px;
    padding: 55px 48px;
    margin-left:102px;
    margin-right:102px;
  }

  /* Left: Ador logo block */
  .la-intro-logo {
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .la-intro-logo img {
    width: 100px;
    height: auto;
    display: block;
  }

  /* Right: text with red left border */
  .la-intro-text {
    flex: 1;
    border-left: 3px solid #EB2019;
    padding-left: 40px;
  }

  .la-intro-para {
    font-family: 'Poppins', sans-serif;
    font-size: 24px;
    font-weight: 500;
    color: #202020;
    line-height: 160%;
  }

  /* ══════════════════════════════════════════
     4. STORIES SECTION
  ══════════════════════════════════════════ */
  .la-stories {
    padding: 0 0 120px 0;
    max-width: 1600px;
    margin: 0 auto;
    background: #ffffff;
  }

  .la-stories-inner {
    padding: 0 102px;
  }

  .la-story-row {
    display: flex;
    align-items: flex-start;
    gap: 80px;
    padding: 0px 0px 60px 0px;
    border-bottom: 1px solid #EB2019;
    margin-bottom:60px;
  }

  .la-story-row:last-child {
     border:none;
         padding: 0px 0px 0px 0px;
  }


  /* Left column — headline */
  .la-story-left {
    flex: 0 0 513px;
  }

  .la-story-headline {
    font-family: 'Poppins', sans-serif;
    font-size: 30px;
    font-weight: 500;
    color: #202020;
    line-height: 160%;
    text-transform: uppercase;
    letter-spacing: 0.01em;
  }

  /* Right column — employee card */
  .la-story-right {
    flex: 1;
  }

  .la-story-name {
    font-family: 'Poppins', sans-serif;
    font-size: 28px;
    font-weight: 400;
    color: #202020;
    line-height: 120%;
    margin-bottom: 15px;
  }

  .la-story-role {
    font-family: 'Poppins', sans-serif;
    font-size: 22px;
    font-weight: 400;
    color: #EB2019;
    line-height: 120%;
    margin-bottom: 20px;
  }

  .la-story-para {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
    margin-bottom: 30px;
  }

  /* Read More button */
  .la-read-more {
    display: inline-block;
    background: #EB2019;
    color: #ffffff;
    font-family: 'DM Sans', sans-serif;
    font-size: 16px;
    font-weight: 500;
    padding: 14px 36px;
    border-radius: 10px;
    text-decoration: none;
    border: none;
    cursor: pointer;
    transition: background 0.2s;
    line-height: 1;
  }

  .la-read-more:hover {
    background: #c91a13;
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — TABLET (max-width: 768px)
  ══════════════════════════════════════════ */
  @media (max-width: 768px) {
    .la-hero             { height: 350px; }
    .la-hero-content     { padding: 0 32px; }
    .la-hero-title       { font-size: 30px; margin-bottom: 16px; }
    .la-hero-divider     { width: 200px; }
    .la-hero-desc        { font-size: 13px; }

    .la-breadcrumb       { padding: 28px 0 0 0; }
    .la-breadcrumb-inner { padding: 0 32px; }
    .la-inner            { padding: 0 32px; }

    .la-intro            { padding: 24px 0px 0px 0px; }
    .la-intro-inner      { padding: 24px 0px; gap: 32px; margin-left: 0px; margin-right: 0px; }
    .la-intro-logo img   { width: 80px; }
    .la-intro-para       { font-size: 15px; }
    .la-story-left { flex: 0 0 280px; }
    
  
    .la-stories-inner    { padding: 0 32px; }
    .la-story-row        { flex-direction: row; gap: 24px; padding: 48px 0px 48px 0px; margin-bottom:0px; }
    // .la-story-left       { flex: none; width: 100%; }
    .la-story-headline   { font-size: 22px; }
    .la-story-name       { font-size: 20px; margin-bottom: 12px; }
    .la-story-role { font-size: 16px;  margin-bottom: 14px;}
    .la-story-para { font-size: 14px;  margin-bottom: 18px;}
    .la-read-more { font-size: 14px;  }

    .la-stories          { padding: 0 0 48px 0; }
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — MOBILE (max-width: 480px)
  ══════════════════════════════════════════ */
  @media (max-width: 480px) {
    .la-hero             { height: 400px; }
    .la-hero-content     { padding: 0 16px; }
    .la-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .la-hero-divider     { width: 180px; margin-bottom: 16px; }
    .la-hero-desc        { font-size: 13px; max-width: 280px; }

    .la-breadcrumb       { padding: 32px 0 0 0; }
    .la-breadcrumb-inner { padding: 0 16px; gap:14px; }
    .la-bc-item          { font-size: 14px; }
    .la-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .la-inner            { padding: 0 16px; }

    .la-intro            { padding: 30px 0; }
        .la-intro-logo img { width: 179px; height:100px;}
    .la-intro-inner      { flex-direction: column; gap: 20px; padding: 30px 0px; align-items: flex-start; margin-left: 0px; margin-right: 0px; }
    .la-intro-text       { padding-left: 0px; border:none }
    .la-intro-para       { font-size: 14px; line-height:160%; }

    .la-stories-inner    { padding: 0 16px; }
    .la-story-row        { flex-direction: column; gap: 15px; padding: 30px 0; }
    .la-story-left       { flex: none; width: 100%; }
    .la-story-headline   { font-size: 20px; line-height:140%; }
    .la-story-name       { font-size: 20px; line-height:129%; margin-bottom:15px; }
        .la-story-role { font-size: 14px; line-height:160%; margin-bottom:15px; }
    .la-story-para       { font-size: 14px; line-height:160%; margin-bottom:30px; }
    .la-read-more        { font-size: 14px; padding: 9px 15px; }

    .la-stories          { padding: 0 0 60px 0; }
      .la-story-row:last-child { padding : 30px 0px 0px 0px;}
  }
`;

/* ── CHANGE: each story now has its own href ── */
const stories = [
  {
    headline:
      "LIMITLESS SKIES …. COUNTLESS OPPORTUNITIES…. MEET UNTIRING CAPABILITIES",
    name: "Shubhadeep BANERJEE",
    role: "SR. Engineer (Manufacturing)",
    para: `One interview, two days and five rounds… that was how Ador Powertron happened to me. Prima facie, the news seemed a pretty nerve-racking one, upon learning that I was supposed to undergo five rounds of interviews. "Why so much of screening for a simple engineer's simple job?" was the question that popped up in my novice mind. `,
    href: "https://www.linkedin.com/pulse/limitless-skies-countless-opportunities-meet-untiring-banerjee/",
  },
  {
    headline: "ADOR – 'THE ALCHEMIST' THAT TURNED ME AROUND",
    name: "Snehal DEORE",
    role: "Lead For Software Integration",
    para: `We're young, we're smart and we're cool, our mere presence is like adrenaline gushing through the ambiance of the place. Home or office, streets or malls, parties or celebrations, every place, juncture or occasion feels bland without us.`,
    href: "https://www.linkedin.com/pulse/ador-alchemist-turned-me-around-snehal-deore/",
  },
  {
    headline: "ADOR – 'THE ALCHEMIST' THAT TURNED ME AROUND",
    name: "Sumeet THAKUR",
    role: "Engineering – Smart Cities & Traffic",
    para: `I had been away in New Zealand for a few years to complete my postgraduate degree in Electricals & Electronics from the Auckland University of Technology. After completing my degree, I had the opportunity to gain valuable work experience as a Research Assistant at the same university as well. `,
    href: "https://www.linkedin.com/pulse/ador-chiselling-outlines-my-career-sumeet-thakur/",
  },
];

export default function LifeAtAdor() {
  return (
    <div className="la">
      <style>{CSS}</style>

      {/* ══ 1. HERO ══ */}
      <section className="la-hero">
        <img className="la-hero-bg" src={HeroBgImg} alt="Life at Ador" />
        <div className="la-hero-overlay" />
        <div className="la-hero-content">
          <h1 className="la-hero-title">Life @ Ador</h1>
          <hr className="la-hero-divider" />
          <p className="la-hero-desc">
            Clean Air and the use of sustainable and renewable energy are
            challenges facing countries around the world.
          </p>
        </div>
      </section>

      {/* ══ 2. BREADCRUMB ══ */}
      <nav className="la-breadcrumb" aria-label="Breadcrumb">
        <div className="la-breadcrumb-inner">
          <a href="/" className="la-bc-item">
            Home
          </a>
          <span className="la-bc-sep">
            <img src={BcSepIcon} alt="" />
          </span>
          <a href="/about-us" className="la-bc-item">
            About Us
          </a>
          <span className="la-bc-sep">
            <img src={BcSepIcon} alt="" />
          </span>
          <span className="la-bc-item active">Life @ Ador</span>
        </div>
      </nav>

      {/* ══ 3. INTRO BANNER ══ */}
      <section className="la-intro">
        <div className="la-inner">
          <div className="la-intro-inner">
            {/* Ador logo left */}
            <div className="la-intro-logo">
              <img src={AdorLogo} alt="Ador Peace of Mind" />
            </div>
            {/* Text right with red left border */}
            <div className="la-intro-text">
              <p className="la-intro-para">
                At Ador Powertron, we are proud to have employees who are
                driven, motivated and adaptable, who would never stop until they
                achieve their dreams! Here's a glimpse into the journey of our
                star employees who made us trustworthy.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ══ 4. STORIES ══ */}
      <section className="la-stories">
        <div className="la-stories-inner">
          {stories.map((s, idx) => (
            <div className="la-story-row" key={idx}>
              {/* Left — headline */}
              <div className="la-story-left">
                <h2 className="la-story-headline">{s.headline}</h2>
              </div>

              {/* Right — employee content */}
              <div className="la-story-right">
                <p className="la-story-name">{s.name}</p>
                <p className="la-story-role">{s.role}</p>
                <p className="la-story-para">{s.para}</p>

                <a
                  href={s.href}
                  className="la-read-more"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Read More
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}